import { useAuth } from 'oidc-react';
import { LoadingIndicator } from './components/LoadingIndicator';
import { removeAuthCookie, setAuthCookie } from './utils/authCookie';

export function withAuth<P extends JSX.IntrinsicAttributes>(
  Component: React.ComponentType<P>,
) {
  const WrappedComponent: React.ComponentType<P> = (hocProps) => {
    const { userData, isLoading } = useAuth();

    if (isLoading) {
      return <LoadingIndicator />;
    }
    
    if (userData?.expired || !userData?.access_token) {
      removeAuthCookie();
      return null;
    }

    setAuthCookie(userData.access_token);
    return <Component {...hocProps} />;
  };

  WrappedComponent.displayName = `withAuth(${Component.displayName})`;

  return WrappedComponent;
}
